import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Watchlist = () => (_jsxs("svg", Object.assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "m11 2v-1h-1.277a1.984 1.984 0 0 0 -3.446 0h-1.277v1h-3v14h12v-14zm-5 0h1a1 1 0 0 1 2 0h1v1h-4zm7 12.923h-10v-11.846h2v.923h6v-.923h2z" }), _jsx("path", { d: "m5 10h6v1h-6z" }), _jsx("path", { d: "m5 7h6v1h-6z" })] })));
Watchlist.iconName = "watchlist";
Watchlist.iconCategory = "Misc - Deprecated";
Watchlist.deprecated = true;
export default Watchlist;
